import React from 'react';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';

const CustomDropdown = ({ label = '', value, onChange, options = [], minWidth = 250, placeholder = 'Select', sxProps = {} }) => {
  return (
    <FormControl sx={{ minWidth, ...sxProps }} size="small" variant="outlined">
      {label && <Typography style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600' }}>{label}</Typography>}
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              '& .MuiMenuItem-root': {
                fontSize: '14px',
                lineHeight: '20px',
                fontWeight: '400'
              },
              '& .MuiMenuItem-root:hover': {
                backgroundColor: 'darkgrey'
              },
              '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: '#420074 !important',
                color: '#fff'
              },
              '& .MuiMenuItem-root.Mui-selected:hover': {
                backgroundColor: '#420074',
                color: '#fff'
              }
            }
          }
        }}
        sx={{
          height: '40px',
          borderRadius: '8px',
          marginTop: 1,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d9d9d9'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#420074'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#420074'
          }
        }}
      >
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropdown;
